import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MenuItem, Select, Box, Typography, Button } from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";

const LanguageSwitcher = ({drawer=false, stripe=false}) => {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(localStorage.getItem("language") || "en");
  const { t } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setLanguage(lng);
    localStorage.setItem("language", lng);
    document.documentElement.lang = lng;
    document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
  };

  useEffect(() => {
    changeLanguage(language); 
  }, []);

  return (
    <>
    {!drawer && 
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minWidth:"85px",backgroundColor: stripe? "#339ace" : "black", opacity: stripe ? "1" :'0.5',padding: stripe? "2px 3px" : "7px 15px",borderRadius: stripe? "15px":"30px", border: "1px solid #339ace", "&:hover": { opacity: 1 }, }}>
      <LanguageIcon  sx={{color: stripe? "white" : "", marginX: "5px" }}/>
      <Select
        value={language}
        onChange={(e) => changeLanguage(e.target.value)}
        variant="standard"
        sx={{  color: "white", 
        '&:before, &:after': {
          borderBottom: 'none !important',
          content: '""',
        },}}
      >
        <MenuItem value="en">English</MenuItem>
        <MenuItem value="ar">العربية</MenuItem>
      </Select>
    </Box>}
      {drawer && <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center",padding: '10px', gap: "10px" }}>
      <LanguageIcon  sx={{ width: "1.2em", height: "1.2em" }}/>
      <Typography variant="body1" sx={{ display: { xs: "none", sm: "block" } }}>
        {t("language")}
        </Typography>
        <Button
          fullWidth
          variant="outlined"
          onClick={() => {
            changeLanguage(language == 'en'? "ar" : "en")
          }}
        >
          {language == 'en'? "العربية": "english"}
        </Button>
     

    </Box>}
    </>
  );
};

export default LanguageSwitcher;
